import { HsabTransactionDetail } from "@/shared/types";
import moment from "moment/moment";

export function filterTransactions (
    lst: HsabTransactionDetail[],
    searchTerm: string,
    creditDebitIndicator?: string): HsabTransactionDetail[] {
    return lst.filter(t =>
            (!creditDebitIndicator || t.creditDebitIndicator === creditDebitIndicator)
            && (!searchTerm
                || (t.description && t.description.toLowerCase().includes(searchTerm.toLowerCase()))
                || (t.checkNumber && t.checkNumber.toLowerCase().includes(searchTerm.toLowerCase()))
                || (t.claimPaymentMethod && t.claimPaymentMethod.toLowerCase().includes(searchTerm.toLowerCase()))
                || (t.claimNumber && t.claimNumber.toLowerCase().includes(searchTerm.toLowerCase()))
                || (t.amount && ("$" + t.amount.toString()).includes(searchTerm))
                || (t.eobNumber && t.eobNumber.toLowerCase() === searchTerm.toLowerCase())
                || moment(t.postingDate).format("MMM D, YYYY").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.postingDate).format("L").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.postingDate).isSame(searchTerm)
                || moment(t.effectiveDate).format("MMM D, YYYY").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.effectiveDate).format("L").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.effectiveDate).isSame(searchTerm)
                || moment(t.paymentDate).format("MMM D, YYYY").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.paymentDate).format("L").toLowerCase().includes(searchTerm.toLowerCase())
                || moment(t.paymentDate).isSame(searchTerm)
            )
    );
}